import Programs from '../../components/consultants/dashboard/Programs'
import { createApp } from 'vue';

if(document.getElementById('consultants-dashboard')){
    const app = createApp({
        components: {
            Programs
        },
    });
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#consultants-dashboard');
}
